import Vue from 'vue'

const state = {
  visible: false,
  componentName: `Base`
}

const getters = {
  visible: state => state.visible,
  componentName: state => state.componentName,
  content: state => state.content
}

const actions = {
  toggleModal ({ commit }, payload) {
    commit(`SAVE_MODAL_STATE`, payload)
  },

  setModalComponentName ({ commit }, payload) {
    commit(`SAVE_COMPONENTS_NAME_TO_STATE`, payload)
  },

  setModalContent ({ commit }, payload) {
    commit(`SAVE_MODAL_CONTENT_TO_STATE`, payload)
  }
}

const mutations = {
  SAVE_MODAL_STATE (state, payload) {
    const toggle = payload || !state.visible
    Vue.set(state, `visible`, toggle)
  },

  SAVE_COMPONENTS_NAME_TO_STATE (state, payload) {
    Vue.set(state, `componentName`, payload)
  },

  SAVE_MODAL_CONTENT_TO_STATE (state, payload) {
    Vue.set(state, `content`, payload)
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
